import { EsPCAReportFilterField } from 'c-sdk';

const exportableFilterKeys = Object.values(EsPCAReportFilterField) as string[];
// useCampaignWrapperState defaults `scheduled` to all three, which is not a narrowing.
const allScheduleValues = ['IN', 'OUT', 'UNBOOKED'];

const isNarrowing = (key: string, values: string[]) =>
    exportableFilterKeys.includes(key) &&
    values?.length > 0 &&
    !(key === EsPCAReportFilterField.Schedule && allScheduleValues.every(v => values.includes(v)));

/**
 * The analytics filters that actually narrow a raw CAD export: known report fields with at least
 * one value, leaving out the default all-schedules selection. Extracted from
 * FilteredCadExportButton so the request it builds can be tested.
 */
export const cadExportFilters = (
    advancedFilters: Record<string, string[]> | null | undefined,
): Record<string, string[]> =>
    Object.fromEntries(
        Object.entries(advancedFilters ?? {}).filter(([key, values]) => isNarrowing(key, values)),
    );
